
import { storage } from './storage.services'

const storageName = 'formData'

const set = (value: any) => storage.set(storageName, value)

const get = () => storage.get(storageName)

const remove = () => {
  storage.remove(storageName)
}

const pageRutValid = (): boolean => {
  const lsFormData: any = get()
  return (lsFormData && Number(lsFormData.code) === 0)
}

const formData = {
  set,
  get,
  remove,
  pageRutValid
}

export { formData }